<template>
  <div class="quick-registration">
    <div class="quick-registration-container">
      <div class="quick-registration-logo"></div>
      <div v-if="id == 1" class="quick-registration-theme-photo">
        <div class="quick-registration-photo-bg"></div>
        <div class="quick-registration-photo-photos"></div>
        <div
          v-for="(photo, index) in 4"
          class="quick-registration-photo"
          :key="index"
          :class="'quick-registration-photo-' + photo"
        ></div>
        <div class="quick-registration-dice quick-registration-dice-1"></div>
        <div class="quick-registration-dice quick-registration-dice-2"></div>
      </div>
      <div v-if="id == 2" class="quick-registration-theme-puzzles">
        <div class="quick-registration-puzzles-bg"></div>
        <div
          v-for="(puzzle, index) in 3"
          class="quick-registration-puzzle"
          :key="index"
          :class="'quick-registration-puzzle-' + puzzle"
        ></div>
        <div
          v-for="(coin, index) in 6"
          class="quick-registration-coin"
          :key="index"
          :class="'quick-registration-coin-' + coin"
        ></div>
      </div>
      <Register class="open"></Register>
      <h1>Игровой <br />сайт знакомств</h1>
      <div class="developer">
        <a href="http://my-green.ru/"></a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Register from "@/components/Blocks/Register";

export default {
  name: "QiuckRegistration",
  components: { Register },
  data() {
    return {
      id: 1,
    };
  },
  computed: {
    ...mapGetters({
      user: "user/fetchUser",
      isEmpty: "user/isEmpty",
    }),
  },
  created() {
    if (!this.isEmpty("user")) {
      this.$router.push({ name: "home" });
    } else {
      document.getElementsByTagName("body")[0].classList.add("landing");
      this.id =
        this.$route.params && this.$route.params.id ? this.$route.params.id : 1;
    }
  },
  beforeDestroy() {
    document.getElementsByTagName("body")[0].classList.remove("landing");
  },
  watch: {
    $route(to, from) {
      // if (to != from) {
      this.id =
        this.$route.params && this.$route.params.id ? this.$route.params.id : 1;
      // }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/styles/pages/_quick-registration";
</style>
